package com.patronat.top.dto
import kotlinx.serialization.Serializable

/**
 * Represents the role of a user in the system.
 */
@Serializable
enum class UserRole {
    CLIENT,
    BUSINESS_OWNER,
    EMPLOYEE,
    MODERATOR,
    SUPER_ADMIN
}